import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { useRetailerStatus } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerStatus";
import { useSettingNamBmSignupLimit } from "@faire/retailer-visitor-shared/settings/useSettingNamBmSignupLimit";
import {
  useAssignSettingSoftCreditCheckForHigherTerms,
  useSettingSoftCreditCheckForHigherTerms,
} from "@faire/retailer-visitor-shared/settings/useSettingSoftCreditCheckForHigherTerms";
import { useCallback } from "react";

import { useReportedMaximumAnnualSales } from "./__internal__/useReportedMaximumAnnualSales";

// 5 million for upmarket and core
// TODO (FD-251744) - shift to a BE config value
const CORE_AND_UPMARKET_ANNUAL_SALES_LIMIT = 5_000_000_00;

export const useSccLimitIncreaseEligibility = () => {
  const isNamBmFoundationalSignupLimit = useSettingNamBmSignupLimit();
  const assignSettingSoftCreditCheckForHigherTerms =
    useAssignSettingSoftCreditCheckForHigherTerms();
  const { isAmerican } = useNationality();
  const { reportedCreationTime } = useRetailerStatus();
  const { reportedMaximumAnnualSales } = useReportedMaximumAnnualSales();

  const getSettingSoftCreditCheckForHigherTerms =
    useSettingSoftCreditCheckForHigherTerms();

  const meetsAnnualSalesCriteria =
    reportedMaximumAnnualSales?.amount_cents &&
    reportedMaximumAnnualSales.amount_cents <=
      CORE_AND_UPMARKET_ANNUAL_SALES_LIMIT;

  const meetsStoreCreationCriteria = ![
    "OPENING_SOON",
    "STARTED_THIS_YEAR",
    "STARTED_ONE_YEAR_AGO",
  ].includes(reportedCreationTime ?? "");

  // implicitly checks if the retailer is logged in
  const eligibleForSccLimitIncreaseExperiment =
    isAmerican &&
    !!meetsAnnualSalesCriteria &&
    meetsStoreCreationCriteria &&
    !isNamBmFoundationalSignupLimit;

  const isTreatmentForSccLimitIncreaseExperiment =
    eligibleForSccLimitIncreaseExperiment &&
    getSettingSoftCreditCheckForHigherTerms;

  const assignSccLimitIncreaseExperiment = useCallback(() => {
    if (eligibleForSccLimitIncreaseExperiment) {
      assignSettingSoftCreditCheckForHigherTerms();
    }
  }, [
    assignSettingSoftCreditCheckForHigherTerms,
    eligibleForSccLimitIncreaseExperiment,
  ]);

  return {
    assignSccLimitIncreaseExperiment,
    isTreatmentForSccLimitIncreaseExperiment,
  };
};
